import { Column, Columns, div, asCurrency } from "lqx-react";
import React, { useMemo } from "react";
import { BoundPolicyBuyer } from "../api/boundPolicy";

export const BoundPolicyBuyerSummary = ({ buyer }: { buyer: BoundPolicyBuyer }) => {
    const limits = useMemo(() => {
        //TODO:Note that for demo on 6/29, assumption is that “already linked invoices = $0; this specific scenario requires persistence of invoice data etc
        // const headroom = buyer.maxCreditLimit - buyer.invoices.models.filter(inv => inv.assetDetails.invoiceStatus == "Awaiting Remittance").reduce((total, invoice) => total += invoice.assetDetails.outstandingAmountSeller, 0);
        const headroom = buyer.maxCreditLimit;
        return ({
            headroom: headroom,
            proFormaHeadRoom: headroom - buyer.invoices.models.filter(inv => inv.assetDetails.invoiceStatus == "Awaiting Remittance").reduce((total, invoice) => total += invoice.assetDetails.outstandingAmountSeller, 0),
        });
    }, [ buyer[ '_changeToken' ] ]);

    return <>
        <SummaryContainer>
            <Columns>
                <Column><SummaryTitle>Approved Limits</SummaryTitle></Column>
            </Columns>
            <Columns>
                <Column><SummaryLabel>Approved Limit:</SummaryLabel></Column>
                <Column><SummaryLabel>Limit Headroom:</SummaryLabel></Column>
                <Column><SummaryLabel>Proforma Headroom:</SummaryLabel></Column>
                <Column><SummaryLabel>Effective Limit:</SummaryLabel></Column>
            </Columns>
            <Columns>
                <Column><SummaryFormValue>{ asCurrency(buyer.maxCreditLimit) }</SummaryFormValue></Column>
                <Column><SummaryFormValue>{ asCurrency(limits.headroom) }</SummaryFormValue></Column>
                <Column><SummaryFormValue>{ asCurrency(limits.proFormaHeadRoom) }</SummaryFormValue></Column>
                <Column><SummaryFormValue>--</SummaryFormValue></Column>
            </Columns>
        </SummaryContainer>
    </>
}

const SummaryLabel = div({
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '11px',
    lineHeight: '15px',
    color: '#8695A4',
    paddingTop: '5px',
    marginTop: '3px',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
});

const SummaryFormValue = div({
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '11px',
    lineHeight: '15px',
    paddingTop: '5px',
    marginTop: '3px',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
});

const SummaryContainer = div({
    background: '#f7fcff',
    paddingTop: '20px',
    paddingBottom: '20px'
});

const SummaryTitle = div({
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontSize: '13px',
    color: '#758da6',
    fontWeight: 800
});